import { FC, useState } from "react";
import { ParticipantsTable, WinnersTable } from "entities/wheel-raffle";
import { Tabs } from "shared/ui";
import {
  useParticipantsPage,
  useWinnersPage,
} from "../../model/useRafflePeoplePage";
import { PeopleSection } from "./PeopleSection";
import { getPeopleTabs } from "./peopleTabs";
import type { PeopleTab } from "./peopleTabs";

import styles from "./RaffleDetailPage.module.css";

interface Props {
  raffleId: number;
  isDrawn: boolean;
  participantsCount: number;
}

export const RafflePeople: FC<Props> = ({
  raffleId,
  isDrawn,
  participantsCount,
}) => {
  // После розыгрыша важнее победители — открываем их первыми.
  const [tab, setTab] = useState<PeopleTab>(
    isDrawn ? "winners" : "participants",
  );
  const participants = useParticipantsPage(raffleId, isDrawn);
  const winners = useWinnersPage(raffleId, isDrawn);

  return (
    <>
      <Tabs
        items={getPeopleTabs(isDrawn, participantsCount, winners.total)}
        active={tab}
        onChange={setTab}
        tabClassName={styles.pill}
        activeClassName={styles.pillActive}
      />
      {tab === "winners" ? (
        <PeopleSection
          state={winners}
          emptyText="No winners"
          renderTable={(items, offset) => (
            <WinnersTable winners={items} offset={offset} />
          )}
        />
      ) : (
        <PeopleSection
          state={participants}
          emptyText="No participants yet"
          renderTable={(items, offset) => (
            <ParticipantsTable participants={items} offset={offset} />
          )}
        />
      )}
    </>
  );
};
